<template>
  <div>
    <div v-if="displayScore === 5" class="star-rate">
      <img src="@/assets/tests/elements-5-12/answer1_correct.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer2_correct.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer3_correct.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer4_correct.png" alt="" />
    </div>
    <div v-if="displayScore === 4" class="star-rate">
      <img src="@/assets/tests/elements-5-12/answer1_correct.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer2_correct.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer3_correct.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer4_incorrect.png" alt="" />
    </div>
    <div v-else-if="displayScore === 3" class="star-rate">
      <img src="@/assets/tests/elements-5-12/answer1_correct.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer2_correct.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer3_incorrect.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer4_incorrect.png" alt="" />
    </div>
    <div v-else-if="displayScore === 2" class="star-rate">
      <img src="@/assets/tests/elements-5-12/answer1_correct.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer2_incorrect.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer3_incorrect.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer4_incorrect.png" alt="" />
    </div>
    <div v-else-if="displayScore === 1" class="star-rate">
      <img src="@/assets/tests/elements-5-12/answer1_incorrect.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer2_incorrect.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer3_incorrect.png" alt="" />
      <img src="@/assets/tests/elements-5-12/answer4_incorrect.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  props: ['score'],
  data() {
    return {
      displayScore: this.score,
    };
  },
};
</script>
<style lang="scss" scoped>
.star-rate {
  display: flex;
  justify-content: space-around;
  max-width: 875px;
  margin: 0 auto;
  margin-top: 1px;
  margin-bottom: 10%;
}
.star-rate img {
  height: 245px;
  width: 170px;
}
.one {
  margin-top: 74px;
}
.four {
  margin-top: 74px;
}
</style>
